import { FolderOpen, Search, RefreshCw, IndianRupee, Users, BarChart3 } from 'lucide-react'
import type { Slide } from './slideData'

const ICON_MAP = {
  FolderOpen,
  Search,
  RefreshCw,
  IndianRupee,
  Users,
} as const

interface SlideCardProps {
  slide: Slide
}

export default function SlideCard({ slide }: SlideCardProps) {
  const Icon = ICON_MAP[slide.iconName]

  return (
    <div className="py-8 px-2 text-center">
      <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-50">
        <Icon className="h-8 w-8 text-blue-600" />
      </div>
      <h2 className="mb-4 text-xl font-bold leading-tight text-gray-900 sm:text-2xl">
        {slide.title}
      </h2>
      <p className="mb-6 text-base leading-relaxed text-gray-500">
        {slide.description}
      </p>
      <div className="inline-flex items-center gap-2 rounded-full bg-amber-50 px-4 py-2 text-sm font-medium text-amber-800">
        <BarChart3 className="h-4 w-4" />
        {slide.stat}
      </div>
    </div>
  )
}
